<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-panel-body>
                <form id="add_template_form">
                    <kt-row>
                        <kt-col lg="6" md="6" sm="12">
                            <kt-form-group>
                                <kt-form-label for="title">
                                    {{ $t('online_contract.title') }}
                                </kt-form-label>
                                <kt-form-control
                                    id="title"
                                    name="title"
                                    v-model="form_data.title"
                                    class="form-control"
                                ></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" sm="12">
                            <kt-form-group>
                                <kt-form-label for="type">
                                    {{ $t('online_contract.type') }}
                                </kt-form-label>
                                <kt-form-select
                                    id="type"
                                    name="type"
                                    v-model="form_data.type"
                                    class="form-control"
                                >

                                    <option
                                        v-bind:key="index"
                                        v-for="(item, index) in contractTemplateType"
                                        v-bind:value="item"
                                    >
                                        {{ contractTemplateTypeStr.get(item) }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" sm="12">
                            <kt-form-group>
                                <kt-form-label for="content">
                                    {{ $t('online_contract.content') }}
                                </kt-form-label>
                                <ckeditor :editor="editor"
                                          id="content"
                                          name="content"
                                          v-model="form_data.content"
                                          :config="editorConfig"
                                          tag-name="content"
                                >
                                </ckeditor>
                            </kt-form-group>
                        </kt-col>

                    </kt-row>
                    <kt-form-action class="mt-4 float-right">
                        <button
                            id="add_template_btn"
                            class="btn btn-md btn-success btn-wide"
                            @click.prevent="addTemplate"
                        >
                            {{ $t('btn.register') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import $ from 'jquery'
import {KTApp} from '@/plugins/core/app'
import {KTUtil} from '@/plugins/core/util';
import {onlineContractService} from '@/common/api.service'
import {i18n} from '@/plugins/i18n'
import mainContent from '@/components/main-content'
import toastr from 'toastr'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import {editorConfig} from '@/constants/ckeditorConfigs'
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import {contractTemplateType, contractTemplateTypeStr} from "@/constants/contractTemplateType";

export default {
    components: {
        'main-content': mainContent,
        ckeditor: CKEditor.component
    },
    mounted() {
        this.runSelectPicker()
    },
    computed: {
        contractTemplateTypeStr() {
            return contractTemplateTypeStr
        },
        contractTemplateType() {
            return contractTemplateType
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    data() {
        return {
            form_data: {},
            editorConfig: editorConfig,
            editor: ClassicEditor,
        }
    },
    methods: {
        addTemplate() {
            let btn = $('#add_template_btn')
            let form = $('#add_template_form')

            form.validate({
                rules: {
                    title: {
                        required: true,
                    },
                }
            });

            if (!form.valid()) {
                return
            }
            KTApp.progress(btn)

            onlineContractService.addTemplate(this.form_data).then(response => {
                this.toastr.success(response.data.message)
                this.$router.push('/online-contract')
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message);
            }).finally(response => {
                KTUtil.scrollTop();
                KTApp.unprogress(btn)
            })
        },
        runSelectPicker() {
            $('.kt-selectpicker').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>